<div class="dialog">
  <div mat-dialog-title>
    <h1 l10nTranslate>shared.assignTo</h1>
    <button mat-button mat-dialog-close class="dialog__close">
      <mat-icon class="mat-icon" svgIcon="close-icon-grey"></mat-icon>
    </button>
  </div>
  <div class="searchContainer">
    <input
      class="searchBox"
      autocomplete="no-autofill"
      [(ngModel)]="searchText"
      [formControl]="searchControl"
      type="search"
      [placeholder]="'shared.search' | xTranslate"
    />
    <em class="fa fa-search searchIcon"></em>
  </div>
  <div class="assign-cards">
    <div mat-dialog-content>
      <div *ngIf="filteredList" class="assign-cards__container">
        <div class="flex-grid">
          <div class="col flex-grid-item contact-card">
            <miq-contact-card
              *ngFor="let user of filteredList | search: searchText"
              [user]="user"
              [selected]="isAssigned(user)"
              (change)="selectUser($event)"
            ></miq-contact-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="primary" class="fx--mt-sm" (click)="assignToUsers()" l10nTranslate>
      shared.assign
    </button>
  </div>
</div>
